import { matchRoute } from '@townsquare/router/primitives/match-route';
import { chatRoute } from '@townsquare/routes/chat';
import { rovoSearchRoute } from '@townsquare/routes/rovo-search-view';
import { searchRoute } from '@townsquare/routes/search';

export function useIsOnRovoSearch(): boolean {
	return !!matchRoute([rovoSearchRoute], window.location.pathname);
}

export function useIsOnFullPageRovoChat(): boolean {
	return !!matchRoute([chatRoute], window.location.pathname);
}

export function useIsOnFullPageSearch(): boolean {
	return !!matchRoute([searchRoute], window.location.pathname);
}
